import { memo as Memo, useEffect, useRef, useCallback, useState } from 'react'
import gsap from 'gsap'
import { useRouter } from 'next/router'

//* Components
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'
import CustomLink from 'components/common/CustomLink'

//* Styles
import MenuItemCollapseStyle from './style'

const MenuItemCollapse = Memo(({ title, slug, children }) => {

    //! Router
    const router = useRouter()

    //! Refs
    const collapseRef = useRef()
    const bodyRef = useRef()

    //! States
    const [open, setOpen] = useState()

    //! Window Click Listener for close
    const handleWindowClick = useCallback((e) => {
        if (!collapseRef.current.contains(e.target)) {
            setOpen(false)
        }
    }, [open])

    //! Did Mount
    useEffect(() => {
        gsap.set(bodyRef.current, { height: 0 })

        window.addEventListener('click', handleWindowClick)

        return () => {
            window.removeEventListener('click', handleWindowClick)
        }
    }, [])

    //! Toggle Body
    useEffect(() => {
        gsap.to(bodyRef.current, { duration: 0.3, height: open ? 'auto' : 0 })
    }, [open])

    //! Handle Collapse Click
    const handleCollapseClick = useCallback(() => {
        setOpen(!open)
    }, [open])

    return (
        <MenuItemCollapseStyle ref={collapseRef} className={`${open ? 'active' : ''}`}>
            <div className="collapse-header" onClick={handleCollapseClick}>
                <Text className={`font-ping-bold h6`} text={title} />
                <span className={`toggle-icon`} />
            </div>

            <div ref={bodyRef} className="collapse-body-cont">
                <div className="collapse-body">
                    {children.map((i, k) => (
                        <div key={k} className={`link-item-cont ${router.asPath === `/${slug}/${i.slug}/` ? 'active' : ''} `}>
                            <CustomLink url={`/${slug}/${i.slug}`} className={`font-helvetica p pS`}>{i.title}</CustomLink>
                        </div>
                    ))}
                </div>
            </div>
        </MenuItemCollapseStyle>
    )
})

export default MenuItemCollapse